import { render, staticRenderFns } from "./statementDetails.vue?vue&type=template&id=7f7f63bc&scoped=true"
import script from "./statementDetails.vue?vue&type=script&lang=js"
export * from "./statementDetails.vue?vue&type=script&lang=js"
import style0 from "./statementDetails.vue?vue&type=style&index=0&id=7f7f63bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7f63bc",
  null
  
)

export default component.exports